import { render, staticRenderFns } from "./childrenComponent.vue?vue&type=template&id=4582144e&scoped=true"
import script from "./childrenComponent.vue?vue&type=script&lang=js"
export * from "./childrenComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582144e",
  null
  
)

export default component.exports